import { render } from "./OverviewDashboard.vue?vue&type=template&id=7da0ed5e&scoped=true"
import script from "./OverviewDashboard.vue?vue&type=script&lang=js"
export * from "./OverviewDashboard.vue?vue&type=script&lang=js"

import "./OverviewDashboard.vue?vue&type=style&index=0&id=7da0ed5e&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da0ed5e"]])

export default __exports__